import store from "../store"

export default {
    getSessionRealEstates: function(real_estates, session) {
        /*
        Returns all RealEstates in a session
        */
        return real_estates.filter(i => String(i.session_id)===String(session.id));
    },
    getSessionMainRealEstate: function(real_estates, session) {
        /*
        Returns main RealEstate in a session
        */
        return real_estates.filter(i => String(i.session_id)===String(session.id) && i.main_property)[0];
    },
    getParcelRealEstates: function(real_estates) {
        /*
        Returns parcel RealEstates
        */
        return real_estates.filter(i => i.real_estate && i.real_estate.is_parcel)
    },
    getUnitRealEstates: function(real_estates) {
        /*
        Returns unit RealEstates
        */
        return real_estates.filter(i => i.real_estate && !i.real_estate.is_parcel)
    },

    getRealEstateType: function(real_estate) {
        /*
        Returns RealEstate type in {id, display} format
        */
        let response = {
            id: null,
            display: null
        }

        if (real_estate.custom_type !== null) {
            response.id = real_estate.custom_type;
            response.display = this._mapRealEstateTypeIdToDisplay(real_estate.custom_type, real_estate.real_estate.is_parcel);
        } else {
            response.id = this._mapRealEstateTypeDisplayToId(real_estate.real_estate.re_type, real_estate.real_estate.is_parcel);
            response.display = real_estate.real_estate.re_type;
        }

        // default value
        if (!response.id) {
            response.id = this._getDefaultRealEstateType(real_estate.real_estate.is_parcel);
            response.display = this._getDefaultRealEstateTypeDisplay(real_estate.real_estate.is_parcel);
        }

        return response;
    },
    _mapRealEstateTypeDisplayToId: function(re_type, is_parcel) {
        // Maps "Stanovanje v enostanovanjski stavbi" to "5000"
        let re_map = store.state.realEstateTypeMap[is_parcel ? "parcel" : "unit"];
        let text_to_id = re_map.reduce(function(map, obj) {
            map[obj.text] = obj.value;
            return map;
        }, {});
        return text_to_id[re_type];
    },
    _mapRealEstateTypeIdToDisplay: function(re_type_id, is_parcel) {
        // Maps "5000" to "Stanovanje v enostanovanjski stavbi"
        let re_map = store.state.realEstateTypeMap[is_parcel ? "parcel" : "unit"];
        let id_to_text = re_map.reduce(function(map, obj) {
            map[obj.value] = obj.text;
            return map;
        }, {});
        return id_to_text[re_type_id];
    },
    _getDefaultRealEstateType: function(is_parcel) {
        return store.state.realEstateTypeMap[is_parcel ? "parcel" : "unit"][0].value.toString();
    },
    _getDefaultRealEstateTypeDisplay(is_parcel) {
        return this._mapRealEstateTypeIdToDisplay(this._getDefaultRealEstateType(is_parcel), is_parcel);
    },
    getRealEstateSize: function(real_estate) {
        /*
        Returns RealEstate size that should be considered in total size.
        */
        let size = real_estate.custom_size ? real_estate.custom_size : real_estate.real_estate.size;
        return Number(size)
    },

    getRealEstateNetSize: function(real_estate) {
        /*
        Returns RealEstate net size. Show in Properties sectio, doesn't consider "korigirana" size.
        */
        let size = real_estate.custom_size ? real_estate.custom_size : real_estate.real_estate.net_size;
        return Number(size);
    },

    getDefaultMainType: function(real_estates, is_parcel) {
        /*
        This is a JS implementation of "AnalysisSession.__get_default_main_type__" method
        Returns default (not custom) main type to be considered for either parcels or units.
        */
        let main_real_estate = real_estates[0];
        if(!main_real_estate || !main_real_estate.real_estate) return null

        let main_type;
        if(main_real_estate.real_estate.is_parcel===is_parcel) {
            main_type = this.getRealEstateType(main_real_estate);
        } else {
            let grouped = {}
            let re_type;
            let main_type_id;
            real_estates = is_parcel ? this.getParcelRealEstates(real_estates) : this.getUnitRealEstates(real_estates);
            real_estates.forEach(re => {
                re_type = this.getRealEstateType(re);
                if(!Object.keys(grouped).includes(re_type.id)){
                    grouped[re_type.id] = 0;
                }
                grouped[re_type.id] += this.getRealEstateSize(re);
            })
            if (Object.keys(grouped).length > 0) {
                main_type_id = Object.keys(grouped).reduce((a, b) => grouped[a] > grouped[b] ? a : b);
            }
            main_type = {
                "id": main_type_id,
                "display": this._mapRealEstateTypeIdToDisplay(main_type_id, is_parcel)
            }
        }
        return main_type;
    },
    getSumRealEstateSizes: function(real_estates, main_type_group) {
        /*
        Returns sum of all RealEstate sizes in session, based on main_type_group (APPARTMENT_GROUP, HOUSE_GROUP, etc.)
        
        !!! IMPORTANT: Keep in sync with Python: AnalysisSession.get_total_unit_size !!!
        Location: apps/analysis/analysis/models.py (line ~295)
        */

        // Map: session.main_type_group -> list of property.main_types to include
        const include_types_map = {
            "HOUSE_GROUP": [
                5000, // "Stanovanje v enostanovanjski stavbi"
                5003, // "Bivalna enota"
                5004, // "Koča, dom"
                5046, // "Stanovanje v dvostanovanjski stavbi"
                5001, // "Stanovanje v večstanovanjski stavbi" -> fixes 2464
            ],
        };
        
        // Map: session.main_type_group -> { property.main_type: size_factor }
        const size_factors_map = {
            "APPARTMENT_GROUP": {
                5014: 0.00,  // "Garaža" - should be ignored
                5015: 0.00,  // "Garažno parkirno mesto"
                5032: 0.03,  // "Klet"
            },
        };
        
        // Get include_types and size_factors for this main_type_group
        const include_types = include_types_map[main_type_group] || null;
        const size_factors = size_factors_map[main_type_group] || {};
        
        // Filter units that have size
        let filtered_real_estates = real_estates;

        // Apply include_types filter if applicable
        if (include_types) {
            filtered_real_estates = filtered_real_estates.filter(re => {
                let type_id;
                if (re.real_estate.unit) {
                    type_id = re.real_estate.unit.unit_type_id;
                } else if (re.real_estate.parcel) {
                    type_id = re.real_estate.parcel.parcel_type_id;
                }
                return include_types.includes(Number(type_id));
            });
        }
        
        // Calculate total size with factors applied
        let total_size = 0;
        filtered_real_estates.forEach(re => {
            let size_factor = 1.0;
            if (re.real_estate.unit) {
                const unit_type_id = re.real_estate.unit.unit_type_id;
                size_factor = size_factors[unit_type_id] !== undefined ? size_factors[unit_type_id] : 1.0;
            }
            total_size += this.getRealEstateSize(re) * size_factor;
        });
        
        return total_size;
    },

    getMainType: function(session, real_estates) {
        let main_real_estate = this.getSessionMainRealEstate(real_estates, session);
        let is_parcel = main_real_estate.real_estate.is_parcel;
        let main_type_id, main_type;
        if (is_parcel && session.custom_main_parcel_type) {
            main_type_id = session.custom_main_parcel_type;
            main_type = {
                "id": main_type_id,
                "display": this._mapRealEstateTypeIdToDisplay(main_type_id, is_parcel)
            }
        } else if (!is_parcel && session.custom_main_unit_type) {
            main_type_id = session.custom_main_unit_type;
            main_type = {
                "id": main_type_id,
                "display": this._mapRealEstateTypeIdToDisplay(main_type_id, is_parcel)
            }
        } else {
            main_type = this.getDefaultMainType(real_estates, is_parcel);
        }
        return main_type;
    }
}
